<template>
    <a
        :href="linkedInLink"
        class="th-btn th-btn-outline th-btn-lg text-sm th-btn-block gap-2 border-[#dadce0]"
    >
        <LinkedInLogoIcon class="th-btn-icon"/>
        <span> {{ t('us.linkedin.title') }} </span>
    </a>
</template>

<script lang="ts" setup>
import { useLinkedInLogin } from '../composables/use-linkedin';
import LinkedInLogoIcon from './LogoLinedIn.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n()

const { linkedInLink } = useLinkedInLogin();
</script>
